module.exports = __webpack_public_path__ + "img/banner.05c27b24.0f86a07d.png";